import { Box, Text } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { StatusHeaderPercentProps } from './StatusHeaderPercent.types';
import { IOS_TEXT_ALIGN_OFFSET } from './StatusHeaderPercent.content';

function StatusHeaderPercent({
  onPercentLayout,
  percent,
  percentX,
}: StatusHeaderPercentProps) {
  return (
    <Box
      position="absolute"
      right="space-0"
      onLayout={onPercentLayout}
      transform={`translate(${percentX}px, ${IOS_TEXT_ALIGN_OFFSET}px)`}
      paddingHorizontal="space-100"
    >
      <Text
        variant="badge-semi"
        color={percentX > 0 ? 'darkSurfaceSecondary' : 'accentSurfacePrimary'}
      >
        {percent}%
      </Text>
    </Box>
  );
}

export default memo(StatusHeaderPercent);
